// extracted by mini-css-extract-plugin
export default {"mainStyle":"LoadingPage_mainStyle__sGuuC","ldsdualring":"LoadingPage_ldsdualring__81wUc","lds-dual-ring":"LoadingPage_lds-dual-ring__0g9Qp"};